import Style from "./css/style.module.css";
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import strFunc from '@/lib/lyg/string';

function PayByDetPopup(props: any) {
  let myProps = {
    select_order_det_arr: [],
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [mcomp_point, set_mcomp_point] = useState<any>(0);
  const [corp_info, set_corp_info] = useState<any>({
    a_response_tel: "",
  });
  const [select_order_det_arr, set_select_order_det_arr] = useState<any>(myProps.select_order_det_arr);

  let checked_cost = 0;
  for (let i = 0; i < select_order_det_arr.length; i++) {
    let order_det = select_order_det_arr[i];
    checked_cost += parseInt(strFunc.uncomma(order_det.a_price));
    checked_cost += parseInt(strFunc.uncomma(order_det.a_price_tax));
  }

  useEffect(() => {
    getPointNumByAjax();
    get_corp_info_by_ajax();
  }, [user]);

  const getPointNumByAjax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  const get_corp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.corp_seq)) {
      return false;
    }
    let formJsonData = {
      "s_seq": [user.corp_seq],
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/corp/corp/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_corp_info(response.data["data"]["info_arr"][0]);
          }
        }
      });
  };

  const callback_select_pay_sort = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: select_order_det_arr,
      pay_sort: "point",//point,payt
      ...inData
    };

    myProps.callbackData(opt_obj);
    myProps.closePopup();
  };

  const go_pay_by_det_by_ajax = (inData: any) => {
    let opt_obj = {
      select_order_det_arr: select_order_det_arr,
      pay_sort: "point",//point,payt
      ...inData
    };

    if (opt_obj.select_order_det_arr.length == 0) {
      alert("결제할 상품이 없습니다.");
      return false;
    }
    if (opt_obj.pay_sort != "point" && opt_obj.pay_sort != "payt") {
      alert("결제수단이 올바르지 않습니다.");
      return false;
    }

    if (opt_obj.pay_sort == "payt") {
      if (strFunc.is_empty(checked_cost)) {
        alert("결제금액이 올바르지 않습니다.");
        return false;
      }
      if (strFunc.is_empty(corp_info.a_response_tel)) {
        alert("학원핸드폰 번호 입력이 필요합니다.(설정>학원정보)");
        return false;
      }
    }
    if (opt_obj.pay_sort == "point") {
      if (mcomp_point < checked_cost) {
        alert("포인트가 부족합니다.");
        return false;
      }
    }

    if (!confirm("선택한 상품을 " + (opt_obj.pay_sort == "point" ? "포인트로" : "결제링크로") + " 결제하시겠습니까?")) {
      return false;
    }

    let order_det_pri_val_arr: any = [];
    for (let i = 0; i < select_order_det_arr.length; i++) {
      let order_det = select_order_det_arr[i];
      let row_pri_val = order_det["a_ymd"] + "," + order_det["a_seq"];
      order_det_pri_val_arr.push(row_pri_val);
    }

    let form_json_data = {
      mcomp_seq: user.comp_seq,
      order_det_seq_arr: order_det_pri_val_arr,
      pay_sort: opt_obj.pay_sort,
      receiv_phone_num: corp_info.a_response_tel,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/pay_by_det', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.pay_sort == "point") {
            alert("결제가 완료되었습니다.");
          } else if (opt_obj.pay_sort == "payt") {
            alert("결제링크로 결제해주시기 바랍니다.");
          }
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });

  };

  const remove_select_order_det = (inData: any) => {
    let opt_obj = {
      pri_val: "",
      ...inData
    };
    let new_select_order_det_arr = [];
    for (let i = 0; i < select_order_det_arr.length; i++) {
      let order_det = select_order_det_arr[i];
      let tmp_pri_val = order_det["a_ymd"] + "," + order_det["a_seq"];
      if (tmp_pri_val != opt_obj.pri_val) {
        new_select_order_det_arr.push(order_det);
      }
    }
    set_select_order_det_arr(new_select_order_det_arr);
  };

  const get_select_order_det_tags = () => {
    let tags: any = select_order_det_arr.map((order_det: any, idx: number) => {
      return (
        <div key={idx} className={Style.order_item}>
          <div className={Style.order_info}>
            <span className={Style.product_name}>{order_det.a_product_name}</span>
            <span className={Style.product_quantity}>x{order_det.a_amount}</span>
          </div>
          <div className={Style.order_actions}>
            <span className={Style.product_price}>{strFunc.comma(order_det.a_price_sum)}원</span>
            <button
              className={Style.remove_button}
              onClick={() => {
                remove_select_order_det({
                  pri_val: order_det["a_ymd"] + "," + order_det["a_seq"]
                });
              }}
            >
              ✕
            </button>
          </div>
        </div>
      );
    });
    return tags;
  };

  return (
    <div className={Style.popup_container}>
      <div className={Style.popup_header}>
        <h2 className={Style.title}>결제 옵션 선택</h2>
      </div>

      <div className={Style.order_list}>
        <h3 className={Style.section_title}>선택한 상품</h3>
        {get_select_order_det_tags()}
      </div>

      <div className={Style.total_section}>
        <span className={Style.total_label}>총 결제금액</span>
        <span className={Style.total_amount}>{strFunc.comma(checked_cost)}원</span>
      </div>

      <div className={Style.popup_content}>
        <h3 className={Style.section_title}>결제 방법</h3>
        <div className={Style.payment_options}>
          <button
            className={`${Style.payment_button} ${Style.point_button}`}
            onClick={() => { go_pay_by_det_by_ajax({}); }}
          >
            <span className={Style.payment_icon}>💰</span>
            <div className={Style.payment_text}>
              <span className={Style.payment_label}>포인트로 결제</span>
              <span className={Style.point_balance}>보유 포인트: {strFunc.comma(mcomp_point)}P</span>
            </div>
          </button>
          <button
            className={`${Style.payment_button} ${Style.card_button}`}
            onClick={() => { go_pay_by_det_by_ajax({ pay_sort: "payt" }); }}
          >
            <span className={Style.payment_icon}>💳</span>
            <div className={Style.payment_text}>
              <span className={Style.payment_label}>결제링크 연결</span>
            </div>
            <div>
              HP : {corp_info.a_response_tel}
            </div>
          </button>
        </div>
      </div>

      <div className={Style.popup_footer}>
        <button
          className={Style.close_button}
          onClick={() => { myProps.closePopup(); }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default PayByDetPopup;